/* eslint-disable */
import axios from "axios";
import { decryptSSNFields, encryptSSNFields } from "./hashSSN";
import handleFormDataEncryption from "./handleFormDataEncryption";
import { decryptAES } from "../decryptAES ";

const axiosInstance = axios.create();

axiosInstance.interceptors.request.use(
	async (config) => {
		const password = process.env.REACT_APP_SSN_ENCRYPTION_PASSWORD || "Gz7!pLw#9XsVq2@dMfBt";

		if (config.params) {
			// // console.log("========>config.params ==>	", config.params);
			const originalParams = { ...config.params };
			config.params = await encryptSSNFields(originalParams, password);
			// console.log("Encrypted Params:", config.params);
		}
		if (config.data instanceof FormData) {
			config.data = await handleFormDataEncryption(config.data, password);
			for (const [key, val] of config.data.entries()) {
				// console.log("Formdataconsolelogcheck--->>", key, "Value:", val);
			}
			return config;
		}
		if (config.data) {
			// console.log("========>config.data ==>	", config.data);

			let originalData;

			//  Only parse if it's a string
			if (typeof config.data === "string") {
				try {
					originalData = JSON.parse(config.data);
				} catch (err) {
					console.error("Failed to parse config.data:", err);
					originalData = {}; // fallback to avoid breaking the request
				}
			} else if (typeof config.data === "object") {
				// Clone to avoid accidental mutation
				if (Array.isArray(config.data)) {
					originalData = config.data;
				} else {
					originalData = { ...config.data };
				}
			} else {
				originalData = {}; // fallback for unknown types
			}

			config.data = await encryptSSNFields(originalData, password);
			// console.log("Encrypted Data:", config.data);
		}

		return config;
	},
	(error) => Promise.reject(error)
);

//response interceptor to decrypt SSN fields
const password = process.env.REACT_APP_SSN_ENCRYPTION_PASSWORD || "Gz7!pLw#9XsVq2@dMfBt";
axiosInstance.interceptors.response.use(
	async (response) => {
		// console.log("=======body 000======>", response.data);
		if (response?.data?.is_result_encrypted) {
			// console.log("Response data is encrypted, decrypting...");
			if (response.data?.is_result_encrypted) {
				for (let index = 0; index < response?.data?.decrypt_fields.length; index++) {
					const element = response?.data?.decrypt_fields[index];
					response.data[element] = JSON.parse(await decryptAES(response.data[element], password));
				}
			}
			// response.data.result = JSON.parse(await decryptAES(response.data.result, password));
			// console.log("🔓 Decrypted Report Response:", response.data);
			return response;
		} else if (response?.data) {
			response.data = await decryptSSNFields(response.data, password);
			// console.log("🔓 Decrypted Response:", response.data);
		}
		return response;
	},
	async (error) => {
		try {
			if (error.response.data?.is_result_encrypted) {
				for (let index = 0; index < error.response?.data?.decrypt_fields.length; index++) {
					const element = error.response?.data?.decrypt_fields[index];
					error.response.data[element] = JSON.parse(await decryptAES(error.response.data[element], password));
				}
			}
		} catch (resErr) {
			console.warn("====== response Error ====================", resErr);
		}

		return Promise.reject(error);
	}
);
export default axiosInstance;
